module.exports = __webpack_public_path__ + "static/media/SPIRITSWAP-FTM-BISON.9a47d6b9.png";